import { AnimatePresence, motion } from 'framer-motion';

export interface StreamTransitionProps {
  /** Key used to trigger exit/enter animation when the stream range or station changes */
  transitionKey: string;
  children: React.ReactNode;
}

/**
 * Wraps stream content with a fade transition so changing station or range
 * animates smoothly instead of swapping content abruptly.
 */
export function StreamTransition({ transitionKey, children }: StreamTransitionProps) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={transitionKey}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15, ease: 'easeOut' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
